<script setup>
const route = useRoute()
const mapName = route.params.area
if (!areaToPrefTable.find(({ key }) => key === mapName)) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
useCustomMeta('area', getPrefectureName(mapName))
const breadCrumbList = getBreadCrumb(mapName)
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <LivecamPrefList
          :area="mapName"
        />
        <LivecamFeature
          :target-key="mapName"
          :title="`（${areaToPrefTable.find(({ key }) => key === mapName).name}）`"
        />
        <LivecamAreaList />
      </div>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
